const Dialog = ({onPictureSelected}) => (<div className="dialogArea"><p>Выберите фото:</p><input type="file" accept="image/*" onChange={e => onFileSelected(e, onPictureSelected)}></input></div>);

const onFileSelected = (e, onReady) => {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => onReady(reader.result);
    
}

export {Dialog};
